import React from 'react';
import { Link as RouterLink } from 'umi';
import { useTheme } from '@material-ui/core';
import clsx from 'clsx';
import { Hidden, IconButton, Toolbar, SvgIcon } from '@material-ui/core';
import { Menu as MenuIcon } from 'react-feather';
import Logo from '@/assets/img/topbar/logo.png';
// import datalake from '@/assets/img/topbar/datalake.png';
// import title from '@/assets/img/topbar/title.png';
import SvgIconML from '../../components/SvgIconML/SvgIconML';
import Exit from './Exit';
import { TopBarStyled } from './TopBarStyled';

// import SvgIconML from '../../components/SvgIconML/SvgIconML';

function TopBar({ className, onMobileNavOpen, ...rest }) {
  const theme = useTheme();

  return (
    <TopBarStyled theme={theme} className={clsx(className)} {...rest}>
      <Toolbar className="toolbar">
        <Hidden className="menu">
          <IconButton
            className="menuButton"
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <SvgIcon fontSize="large" className="menu-icon">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Hidden>
        <Hidden>
          <RouterLink to="/" className="top-logo-left" aria-label="首页">
            <span className="icon">
              <img src={Logo} alt="" />
            </span>
            {/* <span className="dataLake">  <img style={{ height: 33, width: 276 }} src={datalake} alt="" />
            </span> */}
          </RouterLink>
        </Hidden>
        {/* <span className="dataLake">
        </span> */}
        {/* <Box ml={2} flexGrow={1} /> */}
        <Hidden className="title">
          <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <SvgIconML name="dl" className="datalake" />
            {process.env.ENV_NAME === 'prod' ? (
              ''
            ) : (
              <span style={{ fontSize: 28, fontWeight: 600, color: 'red' }}>
                (测试环境)
              </span>
            )}
          </span>
          {/* <span>SMG</span> */}
        </Hidden>
        <Exit />
      </Toolbar>
    </TopBarStyled>
  );
}

export default TopBar;
